import { Component, OnDestroy, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { Subscription } from 'rxjs';

import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { NgcCookieConsentService }    from 'ngx-cookieconsent';
import { CookieService }              from 'ngx-cookie-service';

import { NewsletterComponent } from '../../elements/newsletter/newsletter.component';

import { ThemeManagerService } from 'src/app/core/services/styles/theme-manager.service';
import { CampusService }       from 'src/app/core/services/api/campus.service';

import { Campus }  from 'src/app/core/models/api/campus.model';
import { Edition } from 'src/app/core/models/api/edition.model';


@Component({
    selector: 'app-main',
    templateUrl: './main.component.html',
    styleUrls: ['./main.component.scss']
})
export class MainComponent implements OnInit, OnDestroy {

    public campus     : Campus;
    public loadingData: boolean = true;

    private campusSubscription : Subscription;
    private editionSubscription: Subscription;
    
    public constructor(
        private themeManagerService: ThemeManagerService, 
        private titleService: Title, 
        private campusService: CampusService, 
        private cookieService: CookieService,
        private cookieConsentService: NgcCookieConsentService, 
        private matDialog: MatDialog) { }
    
    ngOnInit() {
        
        this.loadingData = true;
        this.campusService.getCampusByCode().subscribe();
        this.subscribeToCampusService();
        
    }

    ngOnDestroy() {
        
        if (this.campusSubscription  && !this.campusSubscription.closed)  { this.campusSubscription.unsubscribe();  }
        if (this.editionSubscription && !this.editionSubscription.closed) { this.editionSubscription.unsubscribe(); }
        
    }
    
    private subscribeToCampusService() {

        this.campusSubscription = this.campusService.campusActiveData$.subscribe({
            next: () => { 
                this.campus = this.campusService.campusActive;
                this.loadWebPageData();
            }
        });

    }
    
    private loadWebPageData() {

        this.setCampusWebTitle();
        this.setCampusWebTheme();
        this.setCampusWebIcon();
        this.setCookieConsent();
        this.setNewsletterModal();
        this.loadingData = false;

    }

    private setCampusWebTitle() {

        this.titleService.setTitle(this.campus.name);

    }

    private setCampusWebTheme() {

        var findTheme   = this.campus.parameters.find(p => p.parameterId == 'themeSCSS');
        var campusTheme = findTheme != undefined ? findTheme.value : 'default-light-theme'
        this.themeManagerService.setWebTheme(campusTheme);

    }

    private setCampusWebIcon() {
        
        var findIcon   = this.campus.parameters.find(p => p.parameterId == 'favicon');
        var campusIcon = findIcon != undefined ? findIcon.value : 'assets/favicon.ico';

        const favIcon : HTMLLinkElement = document.querySelector('#appIcon') as HTMLLinkElement;
              favIcon.href = campusIcon;

    }

    private setCookieConsent() {

        this.cookieConsentService.init(this.cookieConsentService.getConfig());

    }

    private setNewsletterModal() {

        var newsletterCookie = this.cookieService.get('newsletter');
        if (newsletterCookie === "") {
            this.cookieService.set('newsletter', 'true', { expires: 90 });
            newsletterCookie = 'true';
        } 
        
        if (newsletterCookie === 'true') {

            const newsletterDialogConfiguration : MatDialogConfig = {

                id         : 'newsletter-dialog',
                hasBackdrop: false,
                panelClass : 'custom-newsletter-dialog',
                position   : { bottom: '0px', right: '0px' }
        
            }
    
            this.matDialog.open(NewsletterComponent, newsletterDialogConfiguration);

        }   

    }

    onActivate() {

        document.getElementById('main-content').scrollTo(0,0);

    }

}
